import Founder from "@/components/sections/Founder";

export default function FounderPage() {
  return (
    <div data-testid="founder-page">
      <Founder />
    </div>
  );
}
